import React, { useEffect, useRef, useState } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ParallaxAnimation = ({ children, isMobile, backgroundImage, style }) => {
    const parallaxRef = useRef();
    const [isMobileForParallax1080, setIsMobileForParallax1080] = useState(window.innerWidth <= 1080);
    const [isMobileForParallax500, setIsMobileForParallax500] = useState(window.innerWidth <= 500);
    const [isMobileForParallax375, setIsMobileForParallax375] = useState(window.innerWidth <= 376);

    const [screenSize, setScreenSize] = useState(window.innerWidth);

    useEffect(() => {
        // Cette fonction ajuste isMobileForParallax500 en fonction de la largeur de la fenêtre
        const checkIfMobile1080 = () => {
            setIsMobileForParallax1080(window.innerWidth <= 1080);
        };
        
        const checkIfMobile500 = () => {
            setIsMobileForParallax500(window.innerWidth <= 500);
        };
    
        const checkIfMobile375 = () => {
            setIsMobileForParallax375(window.innerWidth <= 375);
        };
    
        // Ajoute l'écouteur d'événements au montage
        window.addEventListener('resize', checkIfMobile500);
        window.addEventListener('resize', checkIfMobile375);
    
        // Supprime l'écouteur d'événements au démontage
        return () => {
            window.removeEventListener('resize', checkIfMobile500);
            window.removeEventListener('resize', checkIfMobile375);
        };
    }, []);
    

    useEffect(() => {
        if (parallaxRef.current) {
            // Délai plus long pour être sûr que ScrollTrigger est prêt
            const timer = setTimeout(() => {
                const triggerElement = parallaxRef.current;
                
                if (triggerElement && typeof ScrollTrigger !== 'undefined') {
                    try {
                        const movementY = isMobile ? '-25%' : '0%';
                        const movementX = !isMobile ? '-25%' : '0%';
                        
                        const animation = gsap.to(triggerElement, {
                            scrollTrigger: {
                                trigger: triggerElement,
                                start: 'top bottom',
                                end: 'bottom top',
                                scrub: true,
                            },
                            backgroundPositionY: movementY,
                            backgroundPositionX: movementX,
                            ease: 'none',
                        });

                        return () => {
                            if (animation.scrollTrigger) {
                                animation.scrollTrigger.kill();
                            }
                            animation.kill();
                        };
                    } catch (error) {
                        // Si ScrollTrigger n'est pas prêt, pas d'animation parallax
                        console.log('ScrollTrigger not ready yet');
                    }
                }
            }, 500); // Délai augmenté à 500ms

            return () => clearTimeout(timer);
        }
    }, [isMobile, backgroundImage]);

    const getMarginLeft = () => {
        if (screenSize <= 375) {
            return '44vw';
        } else if (screenSize <= 500) {
            return '-32.5vw';
        } else if (screenSize <= 1080){
            return '28vw';
        }
        else {  
            return '10vw';
        }
    };

    useEffect(() => {
        const onResize = () => setScreenSize(window.innerWidth);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
      }, []);
      

    const parallaxStyle = {
        overflow: isMobileForParallax1080 ? 'visible' : 'hidden',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: isMobileForParallax500 ? 'contain' : 'cover',
        backgroundPositionX: isMobileForParallax500 ? 'left' : 'center',
        backgroundPositionY: isMobileForParallax500 ? 'top' : 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        backgroundOrigin: 'border-box', 
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        width: isMobileForParallax1080 ? (isMobileForParallax500 ? '75vw': '67vw') : '40vw',
        marginLeft: getMarginLeft(),
        height: '50vh',
        opacity: '0.95',
        border:'3px solid #F39C2B',
        boxShadow: 'rgba(243, 156, 43, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset',
        marginTop: isMobileForParallax500 ? (isMobileForParallax375 ? '155vw' : '120vw') : '0vh',
        ...style,
    };

    return <div ref={parallaxRef} style={parallaxStyle}>{children}</div>;
};

export default ParallaxAnimation;



// import React, { useEffect, useRef, useState } from 'react';
// import { gsap } from "gsap";
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// const ParallaxAnimation = ({ children, isMobile, backgroundImage }) => {
//     const parallaxRef = useRef();
//     const [isMobileForParallax500, setIsMobileForParallax500] = useState(window.innerWidth <= 500);
//     const [isMobileForParallax375, setIsMobileForParallax375] = useState(window.innerWidth <= 376);

//     useEffect(() => {
//         // Cette fonction ajuste isMobileForParallax500 en fonction de la largeur de la fenêtre
//         const checkIfMobile500 = () => {
//             setIsMobileForParallax500(window.innerWidth <= 500);
//         };
    
//         const checkIfMobile375 = () => {
//             setIsMobileForParallax375(window.innerWidth <= 375);
//         };
    
//         // Ajoute l'écouteur d'événements au montage
//         window.addEventListener('resize', checkIfMobile500);
//         window.addEventListener('resize', checkIfMobile375);
    
//         // Supprime l'écouteur d'événements au démontage
//         return () => {
//             window.removeEventListener('resize', checkIfMobile500);
//             window.removeEventListener('resize', checkIfMobile375);
//         };
//     }, []);
    

//     useEffect(() => {
//         gsap.registerPlugin(ScrollTrigger);

//         if (parallaxRef.current) {
//             const triggerElement = parallaxRef.current;
//             const movementY = isMobile ? '-25%' : '0%';
//             const movementX = !isMobile ? '-25%' : '0%';
            

//             const animation = gsap.to(triggerElement, {
//                 scrollTrigger: {
//                     trigger: triggerElement,
//                     start: 'top bottom',
//                     end: 'bottom top',
//                     scrub: true
//                 },
//                 backgroundPositionY: movementY,
//                 backgroundPositionX: movementX,
//                 ease: 'none',
//             });

//             return () => {
//                 if (animation.scrollTrigger) {
//                     animation.scrollTrigger.kill();
//                 }
//                 animation.kill();
//             };
//         }
//     }, [isMobile, backgroundImage]);

//     const parallaxStyle = {
//         overflow: isMobileForParallax500 ? 'visible' : 'hidden',
//         backgroundImage: `url(${backgroundImage})`,
//         backgroundSize: isMobileForParallax500 ? 'cover' : 'auto',
//         backgroundPositionX: isMobileForParallax500 ? 'left' : 'center',
//         backgroundPositionY: isMobileForParallax500 ? 'top' : 'center',
//         backgroundAttachment: 'fixed',
//         backgroundRepeat: 'no-repeat',
//         backgroundOrigin: 'border-box', 
//         display: 'flex',
//         textAlign: 'center',
//         justifyContent: 'center',
//         alignContent: 'center',
//         width: isMobileForParallax500 ? '75vw' : '40vw',
//         marginLeft: isMobileForParallax500 ? (isMobileForParallax375 ? '51vw' : '-32.5vw') : '10vw',
//         height: '50vh',
//         opacity: '0.95',
//         border:'3px solid #F39C2B',
//         boxShadow: 'rgba(243, 156, 43, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset',
//         marginTop: isMobileForParallax500 ? (isMobileForParallax375 ? '155vw' : '120vw') : '0vh',
//     };

//     return <div ref={parallaxRef} style={parallaxStyle}>{children}</div>;
// };

// export default ParallaxAnimation;


